import { IField } from "./../store/fields/types";
import { ContentType, IInputData } from "../store/fields/boomtypes";

export function toggleAMPM(valueKey: string, value: string) {
    window.handleChange({ id: valueKey, value: value });
}

export function valueChanger(
    handleChange: Function,
    id: IField["_id"],
    newValue: string,
    initialHours: string,
    initialMinutes: string,
    hours: boolean | undefined,
    minutes: boolean | undefined,
    format: string | undefined,
    contentType: ContentType,
) {
    if (newValue.length > 2) return;
    if (contentType === ContentType.PLACEHOLDER) {
        if (hours) {
            if (newValue === "") {
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(newValue, initialMinutes, format),
                });
                return;
            }
            if (/^[0-9]{1,2}$/g.test(newValue)) {
                const value = format ? amPmConvertor(newValue, format) : +newValue > 23 ? "00" : newValue;
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(value, initialMinutes, format),
                });
                return;
            } else if (/^[h]{1,2}$/g.test(newValue.toLowerCase())) {
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(newValue, initialMinutes, format),
                });
            }
            return;
        } else if (minutes) {
            if (newValue === "") {
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(initialHours, newValue, format),
                });
                return;
            }
            if (/^[0-9]{1,2}$/g.test(newValue)) {
                const value = +newValue > 59 ? "00" : newValue;
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(initialHours, value, format),
                });
                return;
            } else if (/^[m]{1,2}$/g.test(newValue.toLowerCase())) {
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(initialHours, newValue, format),
                });
                return;
            }
        }
        return;
    } else if (contentType === ContentType.DEFAULT_TEXT) {
        if (hours) {
            if (newValue === "") {
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(newValue, initialMinutes, format),
                });
                return;
            }
            if (/^[0-9]{1,2}$/g.test(newValue)) {
                const value = format ? amPmConvertor(newValue, format) : +newValue > 23 ? "00" : newValue;
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(value, initialMinutes, format),
                });
                return;
            }
        } else if (minutes) {
            if (newValue === "") {
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(initialHours, newValue, format),
                });
                return;
            }
            if (/^[0-9]{1,2}$/g.test(newValue)) {
                const value = +newValue > 59 ? "00" : newValue;
                handleChange({
                    id: `fields.${id}.input.data.${contentType}`,
                    value: getFormattedValue(initialHours, value, format),
                });
                return;
            }
        }
    }
}

export function getIsTimeActive(defaultText: string, placeholder: string) {
    return (
        defaultText.includes("AM") ||
        defaultText.includes("PM") ||
        placeholder.includes("PM") ||
        placeholder.includes("AM")
    );
}

export function getFormattedValue(hours: string, minutes: string, format: string | undefined) {
    return `${hours}:${minutes} ${format ? format : ""}`;
}

export function amPmConvertor(hours: string, format: string) {
    const amPmTime = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    const defaultTime = ["13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "00"];
    let currentHours = "";
    if (format && +hours >= 24) hours = "00";
    if (format) {
        if (defaultTime.indexOf(hours) >= 0) {
            currentHours = amPmTime[defaultTime.indexOf(hours)];
        } else currentHours = hours;
    } else currentHours = hours;
    return currentHours;
}

export function setDefaultValue(contentType: ContentType, textTime: string) {
    const [time, format] = textTime.split(" ");
    const [hours, minutes] = time.split(":");
    const placeholderDefaultValue = `HH:MM ${format ? format : ""}`;
    const defaultTextDefaultValue = `12:00 ${format ? format : ""}`;
    if (contentType === ContentType.DEFAULT_TEXT) {
        if (!hours && !minutes) {
            return defaultTextDefaultValue;
        } else if (!hours) {
            const value = getFormattedValue("12", minutes, format);
            return value;
        } else if (!minutes) {
            const value = getFormattedValue(hours, "00", format);
            return value;
        }
    } else if (contentType === ContentType.PLACEHOLDER) {
        if (!hours && !minutes) {
            return placeholderDefaultValue;
        } else if (!hours) {
            const value = getFormattedValue("HH", minutes, format);
            return value;
        } else if (!minutes) {
            const value = getFormattedValue(hours, "MM", format);
            return value;
        }
    }
    return "";
}

export function completeInputData(contentType: ContentType, timeText: string) {
    const [time, format] = timeText.split(" ");
    let [dataHours = "", dataMinutes = ""] = time.split(":");
    if (contentType === ContentType.DEFAULT_TEXT) {
        if (dataHours.length === 1 && dataMinutes.length === 1) {
            return getFormattedValue("0" + dataHours, "0" + dataMinutes, format);
        }
        if (dataHours.length === 1) {
            return getFormattedValue("0" + dataHours, dataMinutes, format);
        }
        if (dataMinutes.length === 1) {
            return getFormattedValue(dataHours, "0" + dataMinutes, format);
        }
    } else if (contentType === ContentType.PLACEHOLDER) {
        if (dataHours.length === 1 && dataMinutes.length === 1) {
            const settableHour = dataHours === "H" ? "H" + dataHours : "0" + dataHours;
            const settableMinutes = dataMinutes === "M" ? "M" + dataMinutes : "0" + dataMinutes;
            return getFormattedValue(settableHour, settableMinutes, format);
        }
        if (dataHours.length === 1) {
            const settableHour = dataHours === "H" ? "H" + dataHours : "0" + dataHours;
            return getFormattedValue(settableHour, dataMinutes, format);
        }
        if (dataMinutes.length === 1) {
            const settableMinutes = dataMinutes === "M" ? "M" + dataMinutes : "0" + dataMinutes;
            return getFormattedValue(dataHours, settableMinutes, format);
        }
    }
    return "";
}

export function checkValidData(inputData: IInputData, fieldId: IField["_id"]) {
    let { defaultText, placeholder, contentType } = inputData;
    const [defaultTextTime] = defaultText.split(" ");
    const [placeholderTextTime] = placeholder.split(" ");
    let [defaultTextHours = "", defaultTextMinutes = ""] = defaultTextTime.split(":");
    let [placeholderHours = "", placeholderMinutes = ""] = placeholderTextTime.split(":");

    if (!defaultTextHours || !defaultTextMinutes) {
        defaultText = setDefaultValue(ContentType.DEFAULT_TEXT, defaultText);
    }
    if (!placeholderHours || !placeholderMinutes) {
        placeholder = setDefaultValue(ContentType.PLACEHOLDER, placeholder);
    }

    if (defaultTextHours.length === 1 || defaultTextMinutes.length === 1) {
        defaultText = completeInputData(ContentType.DEFAULT_TEXT, defaultText);
    }
    if (placeholderHours.length === 1 || placeholderMinutes.length === 1) {
        placeholder = completeInputData(ContentType.PLACEHOLDER, placeholder);
    }
    window.handleChange({ id: `fields.${fieldId}.input.data.placeholder`, value: placeholder });
    window.handleChange({ id: `fields.${fieldId}.input.data.defaultText`, value: defaultText });
    window.handleChange({ id: `fields.${fieldId}.input.data.contentType`, value: contentType });
}
